var map = {
	".": 245,
	"./": 245,
	"./Modules.Action": 304,
	"./Modules.Action.ts": 304,
	"./Modules.State": 636,
	"./Modules.State.ts": 636,
	"./UI.New": 637,
	"./UI.New.tsx": 637,
	"./UI.Old": 1078,
	"./UI.Old.tsx": 1078,
	"./icon/1.svg": 6599,
	"./icon/2.svg": 6600,
	"./image/1.png": 6601,
	"./image/2.png": 6602,
	"./image/3.png": 6603,
	"./image/4.png": 6604,
	"./image/5.png": 6605,
	"./image/6.png": 6606,
	"./image/7.png": 6607,
	"./image/8.png": 6608,
	"./image/9.png": 6609,
	"./image/old.png": 6610,
	"./index": 245,
	"./index.scss": 421,
	"./index.tsx": 245
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1077;


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/Guide ^.*$
// module id = 1077
// module chunks = 0